import React from 'react';
import { connect } from 'react-redux';
import { fetchProjects, resetProjects, deleteProject, importProject } from '../../../actions';
import { decode, encode } from 'base-64'

if (!window.btoa) { window.btoa = encode }

if (!window.atob) { window.atob = decode }

class UploadFile extends React.Component {

    constructor(props) {
        super(props);
    }

    componentDidMount() {
        const searchParams = new URLSearchParams(this.props.location.search);
        const a = this.base64ToArrayBuffer(searchParams.get('query').replaceAll(' ', '+'));

        var filename = 'filename.osrtur';
        if(searchParams.has('format')){
            filename = 'filename.' + searchParams.get('format')
        }

        const blob = new Blob([a], { type: "octet/stream" });
        var file = new File([blob], filename)
        this.props.importProject(file)
            .then(() => {
                this.props.history.push('/projects/' + this.props.project.id + '/driver', { state: this.state });
                this.props.history.go('/projects/' + this.props.project.id + '/driver');
            })
            .catch((err) => {
                console.error(err)
            });
    }
    base64ToArrayBuffer(base64) {
        var binary_string = window.atob(base64);
        var len = binary_string.length;
        var bytes = new Uint8Array(len);
        for (var i = 0; i < len; i++) {
            bytes[i] = binary_string.charCodeAt(i);
        }
        return bytes.buffer;
    }
    convertBase64ToFile(image) {
        const byteString = atob(image.split(',')[1]);
        const ab = new ArrayBuffer(byteString.length);
        const ia = new Uint8Array(ab);
        for (let i = 0; i < byteString.length; i += 1) {
            ia[i] = byteString.charCodeAt(i);
        }
        const newBlob = new Blob([ab], {
            type: 'file/xml',
        });
        return newBlob;
    };
    render() {

        return (
            <div className="container-project-cloud-list">
            </div>
        );
    }
}

const mapStateToProps = state => {
    return {
        projects: state.projects != null ? Object.values(state.projects) : null,
        project: state.project.info
    };
};

const mapDispatchToProps = {
    fetchProjects,
    resetProjects,
    deleteProject,
    importProject
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(UploadFile);
